module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Fortune")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9781460303092.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "contents"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")]), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_pt01#ph01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Part I: ")])]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Butterflies")])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry4"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 1")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry5"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_ch02#ch02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 2")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry6"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_pt02#ph02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Part II: ")])]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("The Traveling Show")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry7"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_ch03#ch03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 3")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry8"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_ch04#ch04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 4")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry9"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781460303092_ch05#ch05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 5")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 6")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 7")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 8")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 9")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 10")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 11")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 12")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 13")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 14")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 15")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 16")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 17")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_pt03#ph03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Part III: ")])]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Birds of Prey")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_pt03#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 18")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_pt04#ph04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Part IV: ")])]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chance and Skye")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 19")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 20")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 21")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 22")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 23")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 24")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 25")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 26")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry33"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 27")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry34"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 28")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry35"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 29")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry36"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 30")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry37"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 31")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry38"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 32")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry39"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_pt05#ph05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Part V: ")])]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Fortune")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry40"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 33")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry41"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 34")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry42"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 35")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry43"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 36")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry44"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 37")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry45"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 38")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry46"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 39")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry47"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 40")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry48"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 41")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry49"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 42")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry50"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 43")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry51"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 44")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry52"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 45")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry53"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 46")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry54"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 47")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry55"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 48")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry56"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 49")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry57"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 50")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry58"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 51")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry59"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 52")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry60"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 53")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry61"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 54")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry62"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 55")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry63"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 56")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry64"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 57")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry65"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 58")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry66"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 59")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry67"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 60")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry68"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 61")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry69"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 62")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry70"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 63")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry71"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 64")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry72"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 65")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry73"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch66#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 66")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry74"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 67")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry75"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch68#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 68")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry76"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 69")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry77"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch70#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 70")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry78"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_pt06#ph06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Part VI: ")])]), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Horizon’s End")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry79"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch71#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 71")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry80"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 72")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry81"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 73")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry82"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch74#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 74")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry83"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch75#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 75")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry84"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch76#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 76")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry85"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch77#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 77")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry86"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch78#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 78")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry87"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch79#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 79")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry88"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch80#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 80")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry89"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch81#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 81")])])])])])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry90"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781460303092_ch82#ch82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Chapter 82")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a095ae1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781460303092_contents.vue
// module id = 72
// module chunks = 0